/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { Calendar, Clock, Users, Repeat } from 'lucide-react';
import { motion } from 'framer-motion';

const BookingDetailsCard = ({
  date,
  timeRange,
  duration,
  people,
  recurrenceData,
  recurrenceDisplayText
}) => {
  return (
    <div className="space-y-4">
      <div className="flex gap-4">
        <div className="flex-1 bg-slate-50 p-4 rounded-xl border border-slate-200">
          <div className="flex items-center text-slate-500 mb-2 text-xs">
            <Calendar className="w-4 h-4 mr-1.5" />
            Date
          </div>
          <div className="font-semibold text-slate-900 text-sm">{date}</div>
        </div>

        <div className="flex-1 bg-slate-50 p-4 rounded-xl border border-slate-200">
          <div className="flex items-center text-slate-500 mb-2 text-xs">
            <Clock className="w-4 h-4 mr-1.5" />
            Time
          </div>
          <div className="font-semibold text-slate-900 text-sm">
            {timeRange}
          </div>
        </div>
      </div>

      <div className="flex gap-4">
        <div className="flex-1 bg-slate-50 p-4 rounded-xl border border-slate-200">
          <div className="flex items-center text-slate-500 mb-2 text-xs">
            <Clock className="w-4 h-4 mr-1.5" />
            Duration
          </div>
          <div className="font-semibold text-slate-900 text-sm">{duration} hours</div>
        </div>

        <div className="flex-1 bg-slate-50 p-4 rounded-xl border border-slate-200">
          <div className="flex items-center text-slate-500 mb-2 text-xs">
            <Users className="w-4 h-4 mr-1.5" />
            People
          </div>
          <div className="font-semibold text-slate-900 text-sm">{people}</div>
        </div>
      </div>

      {recurrenceData && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          className="bg-emerald-50 p-4 rounded-xl border border-emerald-200"
        >
          <div className="flex items-center text-emerald-700 mb-2 text-xs">
            <Repeat className="w-4 h-4 mr-1.5" />
            Recurrence
          </div>
          <div className="font-semibold text-emerald-900 text-sm">
            {recurrenceDisplayText}
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default BookingDetailsCard;